export function createUninitializedApiClient(clientName) {
    return new Proxy({}, {
        get: function () {
            return function () {
                throw new Error("".concat(clientName, " API client cannot be accessed outside ").concat(clientName, "ApiClientProvider component."));
            };
        },
    });
}
//# sourceMappingURL=apiClientUtils.js.map